<ey-modal-template [setHeightAuto]="true">
  <div header>Possible loss of data</div>
  <div body>This module contains unsaved changes that will be lost. Do you want to go back?</div>
  <div footer>
    <button class="btn btn--delete" (click)="onGoBack()">Go Back</button>
    <button class="btn btn--secondary" (click)="onCancel()">Cancel</button>
  </div>
</ey-modal-template>
